<div class="wrapper">
  <div
    class="sidebar sidebar-solser-shell"
    data-color="danger"
    data-background-color="black"
  >
    <app-sidebar-cmp></app-sidebar-cmp>
    <div class="sidebar-background"></div>
  </div>
  <div class="main-panel">
    <app-navbar-cmp></app-navbar-cmp>
    <router-outlet></router-outlet>
  </div>
  <!-- Alerta flotante de monitoreo de las matrices de riesgo (15/10/2026). -->
  <app-alerta-monitoreo></app-alerta-monitoreo>
</div>
